import { syncKlaroConsent } from './consent';

const klaroConfig = {
  storageMethod: 'cookie',
  storageName: 'klaro-cookie', // Preserve existing saved choices.
  acceptAll: true,
  hideDeclineAll: false,
  elementID: 'cookie-banner',
  mustConsent: true,
  services: [
    {
      name: 'klaro',
      title: 'Klaro!',
      purposes: ['essential'],
      required: true,
    },
    {
      name: 'google-tag-manager',
      title: 'Google Tag Manager',
      required: true,
      purposes: ['functional'],
      // One callback synchronizes all applied choices before vendor events.
      // Klaro invokes this again when preferences are saved or restored.
      onAccept: syncKlaroConsent,
    },
    {
      name: 'google-analytics',
      title: 'Google Analytics',
      default: false,
      cookies: [/^_ga(?:_|$)/],
      purposes: ['performance'],
    },
    {
      name: 'google-ads',
      title: 'Google Ads',
      default: false,
      cookies: [/^_gcl_/],
      purposes: ['marketing'],
    },
    {
      name: 'meta-pixel',
      title: 'Meta Pixel',
      default: false,
      purposes: ['marketing'],
      cookies: [
        '_fbp',
        '_fbc',
        ['_fbp', '/', '.dotsandlines.io'],
        ['_fbc', '/', '.dotsandlines.io'],
      ],
      required: false,
    },
    {
      name: 'google-double-click',
      title: 'Google Double Click',
      default: false,
      purposes: ['marketing'],
      // This website cannot directly delete cookies on doubleclick.net.
      cookies: [],
      required: false,
    },
    {
      name: 'linkedin',
      title: 'LinkedIn',
      default: false,
      purposes: ['marketing'],
      // Only first-party cookies can be cleaned up by this website.
      cookies: [
        'ln_or',
        'li_fat_id',
        ['ln_or', '/', '.dotsandlines.io'],
        ['li_fat_id', '/', '.dotsandlines.io'],
      ],
      required: false,
    },
  ],
  translations: {
    de: {
      lang: 'de',
      privacyPolicyUrl: '/datenschutz',
      consentModal: {
        title: 'Datenschutz-Einstellungen',
        description: 'Hier kannst du einstellen, welche Dienste verwendet werden dürfen.',
      },
      googleAnalytics: {
        description: 'Statistik über Nutzerverhalten.',
      },
      purposes: {
        analytics: 'Statistiken',
      },
      acceptSelected: 'Auswahl speichern',
      decline: 'Essenzielle Cookies',
    },
    en: {
      lang: 'en',
      privacyPolicyUrl: '/en/privacy-policy',
      consentNotice: {
        description: 'We use cookies to enhance your browsing experience. Learn more in our {privacyPolicy}.',
        learnMore: 'Manage Preferences',
      },
      consentModal: {
        title: 'Cookie Preferences',
        description: 'We use cookies for the following purposes. You can manage your preferences below.',
      },
      ok: 'Accept all',
      decline: 'Essential Cookies',
      acceptSelected: 'Accept Selected',
      save: 'Save',
      close: 'Close',
      acceptAll: 'Accept All',
      googleAnalytics: {
        title: 'Google Analytics',
        description: 'Helps us understand and improve user experience on our website.',
      },
    }
  },
};

export default klaroConfig
